import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler, toastError } from "../../../shared/services/errors/erros-handler";
import { loginFormData } from "../schema/login.schema";

interface IAuthProps {
    accessToken: string;
    permissions: string[];
    idUserLogado: string;
    idCompany: string;
    avatar: string;
    name: string;
    companyConfig: {
        alicota: string;
        cancelFinancialMovement: boolean;
        cancellationPeriod: number;
        filtTotalChargesPercent: number;
    }
}

const auth = async (data: loginFormData): Promise<IAuthProps | Error> => {
    try {
        const response = await baseApiService.post('/auth/login', data);
        if (response?.data) {
            return response.data;
        }
        return new Error("Erro ao efetuar Login") || window.alert("Erro ao efetuar Login");
    } catch (err) {
        const erroData = errosHandler(err)
        throw window.alert(erroData.mensagem)
    }
};

export const loginService = {
    auth
}